import * as React from 'react';
import NoteComponent from "../components/NoteComponent/NoteComponent";

import {connect} from "react-redux";
import {shortlistRemove} from "../actions/literatureWizardActions";
import IShortlistable from "../interfaces/IShortlistable";
import IShortlistElement from "../interfaces/IShortlistElement";

export interface INoteProps {
    dispatchShortlistRemove: (type: IShortlistable, value: any) => any,
    shortlist: IShortlistElement[]
}

class NoteContainer extends React.PureComponent<INoteProps> {
    public render() {
        return (
            <NoteComponent {...this.props}/>
        );
    }
}

const mapStateToProps = (store: any) => ({
    shortlist: store.literature.shortlist
});

const mapDispatchToProps = {
    dispatchShortlistRemove: shortlistRemove
};

export default connect(mapStateToProps, mapDispatchToProps)(NoteContainer);


// WEBPACK FOOTER //
// ./src/containers/NoteContainer.tsx